import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * Health & AI accuracy disclaimer.
 * variant: 'inline' (subtle text) | 'card' (bordered card)
 */
export const Disclaimer = ({ variant = 'inline', className = '' }) => {
  if (variant === 'card') {
    return (
      <div
        data-testid="disclaimer-card"
        className={`backdrop-blur-xl bg-[#E5A84B]/5 border border-[#E5A84B]/20 rounded-2xl p-4 ${className}`}
      >
        <div className="flex items-start gap-3">
          <AlertTriangle className="w-5 h-5 text-[#E5A84B] mt-0.5 flex-shrink-0" />
          <div className="space-y-1">
            <p className="text-xs text-[#7A7A72] dark:text-[#A1A1AA] leading-relaxed">
              <span className="font-semibold text-[#1A3A4A] dark:text-[#F0EDE8]">Important:</span>{' '}
              Nuri uses AI to estimate nutritional content and may make mistakes. This app is not a substitute for professional medical or nutritional advice. Always consult a qualified healthcare provider for dietary guidance.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <p
      data-testid="disclaimer-inline"
      className={`text-[10px] text-white/60 dark:text-[#A1A1AA]/60 leading-relaxed text-center text-over-image ${className}`}
    >
      AI-estimated values may be inaccurate. Not a substitute for professional medical or nutritional advice.
    </p>
  );
};

export default Disclaimer;
